<template>
  <div class="row text-center my-4">
    <div class="col-md-12 g-0 mt-5 mb-5" id="programas">
      <h2>Vuelve a ver todos los programas</h2>
      <VueSlickCarousel v-bind="settings">
        <div class="item">
          <p><strong>#EpicDay!</strong>24 horas de ofertas imperdibles</p>
          <img src="/img/post/9.png" @click="displayModal('7Q-hFHOEYYA')" class="img-fluid px-2" role="button">
        </div>
        <div class="item">
          <p><strong>#GalaxyA</strong>Serie Galaxy A33 │ A53 │ A73</p>
          <img src="/img/post/8.png" @click="displayModal('0u3Hnksr5-g')" class="img-fluid px-2" role="button">
        </div>
        <div class="item">
          <p><strong>#GalaxyA</strong>Serie Galaxy A33 │ A53 │ A73</p>
          <img src="/img/post/8.png" @click="displayModal('0u3Hnksr5-g')" class="img-fluid px-2" role="button">
        </div>
        <div class="item">
          <p><strong>#GalaxyBook2</strong>Nueva serie Galaxy Book 2</p>
          <img src="/img/post/7.png" @click="displayModal('nLuuUhQXsJk')" class="img-fluid px-2" role="button">
        </div>
        <div class="item">
          <p><strong>#mothersnight</strong>El regalo perfecto</p>
          <img src="/img/post/0.png" @click="displayModal('AjccGcAPikA')" class="img-fluid px-2" role="button">
        </div>
        <div class="item">
          <p><strong>#SLiveShop</strong>en donde se vieron ofertas increíbles</p>
          <img src="/img/post/1.png" @click="displayModal('OJVsrkl8UfE')" class="img-fluid px-2" role="button">
        </div>
        <div class="item">
          <p><strong>#GalaxyS21FE</strong>junto a Joaquín Méndez y Elías Inostroza</p>
          <img src="/img/post/2.png" @click="displayModal('s3Oy_CUOykc')" class="img-fluid px-2" role="button">
        </div>
        <div class="item">
          <p><strong>#ZLiveShow</strong>evento animado por Joaquín Mendez</p>
          <img src="/img/post/3.png" @click="displayModal('ItqT0_QUeP0')" class="img-fluid px-2" role="button">
        </div>
        <div class="item">
          <p><strong>#LifestyleTV</strong>cuál es el modelo que mejor se adapta a tu estilo</p>
          <img src="/img/post/4.png" @click="displayModal('HhoYWThp-vQ')" class="img-fluid px-2" role="button">
        </div>
        <div class="item">
          <p><strong>#GalaxyS21 5G en Chile</strong> junto a Jean Philippe</p>
          <img src="/img/post/5.png" @click="displayModal('wAYxxEnhQUA')" class="img-fluid px-2" role="button">
        </div>
        <div class="item">
          <p><strong>#SamsungLiveShop</strong> Con Joaquín Méndez y Elias Inostroza</p>
          <img src="/img/post/6.png" @click="displayModal('CHLGpp_mEnM')" class="img-fluid px-2" role="button">
        </div>
      </VueSlickCarousel>
<!--      OJVsrkl8UfE-->
    </div>
    <div class="modal-video" v-if="showmodal">
      <div class="modal-content">
        <div class="btncerrar" role="button" @click="closeModal">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"/></svg>
        </div>
        <iframe :src="`https://www.youtube-nocookie.com/embed/${modalid}`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";

export default {
  name: "Programas",
  components: { VueSlickCarousel },
  data() {
    return{
      showmodal: false,
      modalid: '',
      settings: {
        "dots": true,
        "focusOnSelect": true,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 3,
        "slidesToScroll": 3,
        "touchThreshold": 5,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,
              "infinite": true,
              "dots": true
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 2,
              "slidesToScroll": 2,
              "initialSlide": 2
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1
            }
          }
        ]
      }
    }
  },
  methods:{
    displayModal(id){
      this.modalid = id
      this.showmodal = true
    },
    closeModal(){
      this.showmodal = false
      this.modalid = ''
    }
  },
}
</script>

<style lang="scss" scoped>
.slick-slider{
  margin: 0 10px;
  padding: 0 10px;
}
.item{
  position: relative;
  p{
    position: absolute;
    bottom: 0;
    width: 80%;
    margin: 1em;
    color: white;
    text-align: left;
    font-size: 0.9em;
    strong{
      display: block;
    }
  }
}
.modal-video{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,.6);
  display: flex;
  z-index: 9;
  .btncerrar{
    display: block;
    width: 24px;
    height: 24px;
    background: white;
    border-radius: 50%;
    padding: 0;
    position: absolute;
    right: -10px;
    top: -10px;
  }
  .modal-content{
    background: transparent;
    margin: auto;
    aspect-ratio: 16/9;
    position: relative;
    width: 70%;
    @media only screen and (max-width: 480px) {
      margin: 1em auto;
      width: 92%;
    }
    iframe{
      width: 100%;
      aspect-ratio: 16/9;
    }
  }
}
#programas{
  .slick-prev:before, .slick-next:before{
    color: black;
  }
  .slick-next{
    right: -10px;
  }
  .slick-prev{
    left: -10px;
  }
}

.black{
  background: black;
}
.centered{
  margin: 0 auto;
  display: block;
}
.botones{
  display: flex;
  justify-content: center;
  margin-top: 15px;
  @media only screen and (max-width: 480px) {
    padding-bottom: 30px;
  }
}
.boton-blanco{
  margin: 0 10px;
}
.block {
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  width: 33%;
  align-items: center;
  position: relative;
  &::after{
    content: ':';
    position: absolute;
    top: -20px;
    right: -7px;
    font-size: 4em;
  }
  &:nth-child(3n)::after{
    display: none;
  }
  &:last-child{
    border-right: none;
    display: none;
  }
  @media only screen and (max-width: 480px) {
    margin: 0;
  }
}

.text {
  font-size: 0.7rem;
  text-align: center;
  margin: 5px;
  margin-top: 0;
  text-transform: uppercase;
}

</style>